import { DataRequestProject } from '../../../models/DataRequestHub/DataRequestProject';
import { ProjectProgressStatus } from '../../../models/DataRequestHub/ProjectProgressStatusEnum copy';

export class DataRequestHelpers {
    public static isReadonlyProject(projects: DataRequestProject[]): boolean {
        return (
            projects.length > 0 &&
            projects.every(
                (project) =>
                    project.isExternalProject &&
                    project.status === ProjectProgressStatus.Complete
            )
        );
    }
}
